import moment from 'moment';
import { type OneDriveFile, type OneDriveFolder } from '../../types';
import SecondaryTableCell from './SecondaryTableCell';

type LastModifiedTableCellProps = {
  oneDriveItem: OneDriveFile | OneDriveFolder;
};

const LastModifiedTableCell = ({
  oneDriveItem,
}: LastModifiedTableCellProps) => {
  const lastModifiedAt = moment(oneDriveItem.lastModifiedDateTime);
  const now = moment();

  if (now.subtract(22, 'hours').isBefore(lastModifiedAt)) {
    return <SecondaryTableCell>{lastModifiedAt.fromNow()}</SecondaryTableCell>;
  }

  return <SecondaryTableCell>{lastModifiedAt.format('L')}</SecondaryTableCell>;
};

export default LastModifiedTableCell;
